import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const negatives = ['This is not a random collection of driving tips.', 'This is not a generic learner-driver theory book.', 'This is not a collection of disconnected worksheets.', 'And it is not another resource that leaves you with hours of preparation before you can actually use it.'];
const workflow = [{
  step: 'OPEN',
  detail: 'Open the system.'
}, {
  step: 'CHOOSE',
  detail: 'Choose the objective.'
}, {
  step: 'SEE',
  detail: 'Show the visual.'
}, {
  step: 'TEACH',
  detail: 'Teach the lesson.'
}];
const ease = [0.23, 1, 0.32, 1] as const;
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-blue-950 relative overflow-hidden" data-id="element-249" data-mp="13zy18j7toi84">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-1 bg-orange-500" data-id="element-250" data-mp="142tys6frd4w1" />

      <div className="max-w-4xl mx-auto text-center" data-id="element-251" data-mp="2jj2gjuq44vft">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease
      }} data-id="element-252" data-mp="2feut00ve5lj6">
          <p className="text-sm md:text-base font-semibold text-white/80 mb-4" data-id="element-253" data-mp="2gth2d9qrnx2r">
            The Complete Driving Teaching System for Instructors Worldwide
          </p>
          <h2 className="text-3xl md:text-5xl font-serif font-extrabold mb-4 text-white" data-id="element-254" data-mp="2pw04frmqa5ny">
            DRIVING INSTRUCTOR <span className="text-orange-500" data-id="element-255" data-mp="1t60ovd85u6vv">READY</span>
          </h2>
          <p className="text-base md:text-lg text-white font-semibold mb-1" data-id="element-256" data-mp="1x6jh38dyteyl">
            A Complete 6-in-1 Visual Teaching System
          </p>
          <p className="text-base md:text-lg text-white/75 mb-10" data-id="element-257" data-mp="22547yh7bumad">
            6 Complete Volumes · 150 Ready-to-Teach Lessons · 5 Professional Bonus Guides · 100%
            Visual
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-258" data-mp="19gyl9owpqn7w">
          <motion.div initial={{
          opacity: 0,
          x: -12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease
        }} className="space-y-3 bg-white/5 p-6 rounded-2xl border border-white/15" data-id="element-259" data-mp="1efjozyb6bp13">
            {negatives.map(statement => <div key={statement} className="flex items-start gap-3" data-id="element-260" data-mp="2qln62wg9c8zd">
                <X className="text-red-400 shrink-0 mt-1" size={18} data-id="element-261" data-mp="2mj8nmdgi3b8m" />
                <p className="text-white/75 text-sm" data-id="element-262" data-mp="1yruz6ilgzzsx">{statement}</p>
              </div>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease
        }} className="bg-white p-6 rounded-2xl border-2 border-orange-500" data-id="element-263" data-mp="1tul9d1u65m4k">
            <div className="flex items-start gap-3" data-id="element-264" data-mp="3j76mrtjmq0lq">
              <Check className="text-green-600 shrink-0 mt-1" size={20} data-id="element-265" data-mp="3ja13pb3fp3ae" />
              <p className="text-blue-950 font-medium text-base leading-relaxed" data-id="element-266" data-mp="3e8vcxitc3q3i">
                Driving Instructor Ready is a complete visual teaching system created specifically
                for instructors who want to plan less, explain skills more clearly, correct students
                more effectively and create stronger lesson progression.
              </p>
            </div>
          </motion.div>
        </div>

        <div className="mt-12" data-id="element-267" data-mp="9b93u8m7jn5u">
          <p className="text-white/80 text-sm font-semibold uppercase tracking-widest mb-5" data-id="element-268" data-mp="9azdul15xg05">
            The system follows a simple workflow
          </p>
          <ol className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-0" data-id="element-269" data-mp="ec56yjyqj5a7">
            {workflow.map((item, index) => <li key={item.step} className="relative flex flex-col items-center px-2" data-id="element-270" data-mp="4k999a0k9h6i" data-mpi={index}>
                <span className="text-2xl md:text-3xl font-serif font-extrabold text-orange-500" data-id="element-271" data-mp="sa3kxo958zp6">
                  {item.step}
                </span>
                <span className="text-sm text-white/80 mt-1" data-id="element-272" data-mp="x1ljy6rlwq7i">{item.detail}</span>
                {index < workflow.length - 1 && <span className="hidden md:block absolute right-0 top-2 translate-x-1/2 text-2xl text-white/40" aria-hidden="true" data-id="element-273" data-mp="34i20l96fgseo">
                    →
                  </span>}
              </li>)}
          </ol>
        </div>
      </div>
    </section>;
}